import { makeStyles } from '@material-ui/core';
import { vh } from '../../common/helpers/dimension-helper';
import { themeColor } from '../../mui-theme';

export const styles = makeStyles(theme => ({
  tareWeightContainer: {
    paddingLeft: '0.5vw',
    height: '11vh',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '77%',
    justifyContent: 'center',
    alignContent: 'flex-start',
  },
  tareWeightBox: {
    position: 'relative',
    overflow: 'hidden',
  },
  tareWeightBoxContainer: {
    margin: '2vh 0',
  },
  subHeading: {
    fontSize: vh(2.08),
    fontWeight: 500,
    display: 'inline-block',
    color: themeColor.defaultTextColor,
    letterSpacing: '0.18vh',
    lineHeight: '2.08vh',
    alignSelf: 'center',
  },
  productBox: {
    display: 'inline-block',
  },
  price: {
    height: '2.6vh',
    fontSize: vh(1.82),
    lineHeight: 1.43,
    letterSpacing: 0.25,
    color: theme.palette.info.dark,
  },
  gridPrice: {
    position: 'relative',
    top: '10.5px',
    textAlign: 'center',
  },
  selectedItem: {
    borderColor: theme.palette.secondary.main,
    borderWidth: '3px',
  },
  gridContainerSpacing: {
    marginLeft: '2vh',
    alignItems: 'flex-end',
  },
  containerSpacing: {
    overflow: 'hidden',
  },
  inputTextField: {
    width: '500px',
    marginTop: '2vh',
  },
  linkedTareWeightItemCard: {
    '@media (max-width: 1024px)': { width: '13vw' },
    width: '11vw',
    height: '7.1146vh',
    backgroundColor: themeColor.white,
    border: `1px solid ${themeColor.secondaryLight}`,
    marginRight: '0.797vh',
    cursor: 'pointer',
    marginBottom: '0.797vh',
    padding: '1.04vh',
    position: 'relative',
    overflowWrap: 'break-word',
  },
  linkedTareWeightItemCardHeader: {
    fontSize: vh(2.12),
    lineHeight: '2.39vh',
    fontWeight: 500,
    textAlign: 'center',
    wordBreak: 'break-word',
    marginTop: '1vh',
  },
  pagination: {
    paddingLeft: '7vw',
    minWidth: '15vw',
  },
}));
